var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<iframe title=\"youtube video\" ng-if=\"$wbYouTubeVideoCtrl.youtubeUrl\" width=\"560\" height=\"315\" ng-src=\"{{$wbYouTubeVideoCtrl.trustSrc($wbYouTubeVideoCtrl.youtubeUrl)}}\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>";
var id1="javascripts/youtube-video/youtube_video.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/javascripts/youtube-video/youtube_video.template.html
// module id = 1328
// module chunks = 0